module.exports = __webpack_public_path__ + "img/oval-grey.733aecc8.svg";